<template>
  <ion-app>
    <router-view></router-view>
  </ion-app>
</template>

<script>
import EoppService from '../mixins/EoppService.js'
import {AuthState, onAuthUIStateChange} from '@aws-amplify/ui-components'
import {IonApp} from "@ionic/vue";

export default {
  name: 'AccountVue',
  mixins: [EoppService],
  components: {
    IonApp,
  },
  created() {
    onAuthUIStateChange((authState) => {
      console.log(authState);
      if (authState === AuthState.SignedIn && this.$router.currentRoute.name !== 'Home') {
        this.$router.push({name: 'Home'});
      } else if (authState === AuthState.SignIn && this.$router.currentRoute.name !== 'Login') {
        this.$router.push({name: 'Login'});
      } else if (authState === AuthState.SignUp && this.$router.currentRoute.name !== 'Signup') {
        this.$router.push({name: 'Signup'});
      }
    });
  },
  data() {
    return {
      status: null,
    };
  },
  mounted() {
    console.log('Mounted - Account');
    this.getAccountLead().then(res => {
      console.log(res.data);
      console.log(res.data);
      this.$store.commit('leadInfo', res.data);
    })
  }
}
</script>

<style>

</style>
